@if (!isDuration15Minutes()) {
  <header 
    class="card__header" 
    [attr.data-header-point-scroll-index]="indexCard()"
  >
    <div class="header__overlay"></div>
    
    <div class="header__saturated-duration">
      @if(isVerySaturatedPoint()) {
        <app-very-satured-chip />
      } @else if (isSaturatedPoint()) {
        <app-satured-chip />
      }
      
      <span class="header__duration">
        {{ point().duration | duration }}
      </span>
    </div>
  </header>
}